/*@ngInject*/
const DetailedHistoryRepository = function (baseRepository, sortUtil, coreMediator) {

    angular.extend(this, baseRepository);

    this.getParams = function(requestParams) {
        var params = {
            submissionId: requestParams.submissionId,
            accountId: requestParams.accountId,
            filterText: requestParams.searchString,
            filterFields: requestParams.filterFields,
            timeRange: requestParams.timeRange,
            startIndex: requestParams.startIndex,
            numberOfRows: requestParams.numberOfRows
        }
        return params;
    };

    this.getDetailedHistory = function (requestParams) {
        var params = this.getParams(requestParams);
        var url = '/rest/Audit',
            config = {
                params: params
            };
        return this.get(url, config).then(function (responseData) {
            var sortedRecords = responseData.records.sort(sortUtil.naturalSortObject(requestParams.key));

            if (requestParams.sortType === 'desc') {
                sortedRecords.reverse();
            }
            responseData.records = sortedRecords;
            return responseData;
        });
    };

    this.getDownloadUrl = function(requestParams, type) {
        let paramsString = "&currentState=submission",
            params = this.getParams(requestParams);

        for (var key in params) {
            var value = params[key];
            if (value && value!='') {
                paramsString += "&" + key + "=" + encodeURIComponent(value);
            }
        }

        return coreMediator.getSingleUseToken().then((token) => {
            paramsString += "&t=" + encodeURIComponent(token);
            return "/auditLogData/DetailedHistory." + type + "?exportType=" + type + paramsString;
        });
    };

};

angular.module('gw-um-submission')
    .service('detailedHistoryRepository', DetailedHistoryRepository);
